import { axiosInstance } from '../../Utils/apiServices';

/**
 * Send/Resend OTP to email or mobile
 * @param {{id: string}} payload will have either mobile or email
 */
export const requestForOTP = async (payload) => {
  const path = `getOtp`;

  return axiosInstance
    .request({
      url: `${encodeURI(path)}`,
      method: 'get',
      params: {
        email: payload.id,
      },
    })
    .then((res) => res.data);
};

export const requestOneTimeOtp = async (payload) => {
  const path = `onetimepassword`;
  return axiosInstance
    .get(path, {
      params: {
        email: payload.id,
        phone: payload.phone,
      },
    })
    .then((res) => {
      return res.data;
    });
};

/**
 * Verify OTP for user login or signup
 * @param {{id: string, otp: string}} payload will verify otp for email or mobile
 */
export const verifyOTP = async (payload) => {
  const path = `verifyOtp`;

  return axiosInstance
    .request({
      url: `${path}`,
      method: 'get',
      params: {
        email: payload.id,
        otp: payload.otp,
      },
    })
    .then((res) => res.data);
};

export const verifyOneTimeOTP = async (payload) => {
  const path = `verifyemailwithoutcontact`;
  return axiosInstance
    .post(path, payload)
    .then((res) => {
      return res.data;
    });
};

/**
 * User Signup Request
 * @param {*} payload
 */
export const signUp = async (payload) => {
  const path = `signup`;

  return axiosInstance
    .request({
      url: `${path}`,
      method: 'post',
      data: {
        applicant: {
          firstName: payload.firstName,
          lastName: payload.lastName,
          middleName: payload.middleName,
          email: payload.email,
          phone: payload.phone,
          // date: payload.date,
          // program: payload.program,
        },
      },
    })
    .then((res) => res.data);
};